/* @flow */
'use strict';

import {ajaxSubmit} from '../lib/form';
import $ from 'jquery';

declare var FpJsFormValidator;

require('../lib/formValidator/adfinance.email');

function showErrorAtField(path: Array<string>, message: string) {
    let pathFragment = path.shift();
    let element = FpJsFormValidator.forms[pathFragment];

    while (path.length > 0) {
        pathFragment = path.shift();
        element = element.children[pathFragment];
    }

    let sourceId = 'form-error-' + String(element.id).replace(/_/g, '-');
    element.showErrors.apply(element.domNode, [[message], sourceId]);
}

function proceed($form) {
    let hidden = 'hidden';
    let current = $form.closest('.leadbox-stage');
    let stage = parseInt(current.data('stage'),10);

    //Staging
    if(stage != 0) {
        let expectedStep = stage + 1;

        if($form.closest('.leadbox.staged').find('.leadbox-stage[data-stage='+expectedStep+']').length > 0) {
            current.addClass(hidden);
            $form.closest('.leadbox.staged').find('.leadbox-stage[data-stage='+expectedStep+']').removeClass(hidden);
        } else if(current.find('.leadbox-overlay[data-stage=end]').length > 0) {
            $form.find('.row.form-group').addClass('has-success');
        } else {
            current.addClass(hidden);
            $form.closest('.leadbox.staged').find('.leadbox-stage[data-stage=end]').removeClass(hidden);
        }
    }

    //Google Analytics
    let gaAction = current.data('ga-action');
    let gaTag = current.data('ga-tag');

    if(gaTag  != 'undefined' && gaAction != 'undefined') {
        dataLayer.push({
            'event': 'ga.event',
            'eCategory': 'Článek',
            'eAction': gaAction,
            'eLabel': gaTag,
            'eNonInteraction': true
        });
    }
}

$(function () {
   let $forms = $('.leadbox form');

   if($forms.length === 0) {
       return;
   }

   $forms.on('submitValid', function(e) {
      let submitEvent = e.detail.submitEvent;
      submitEvent.preventDefault();
      let $form = $(submitEvent.target);

      $form.removeClass('has-success');

      ajaxSubmit($form).then(function (response) {
          let canGoAway = true;

          if(response.errors && response.errors.length > 0) {
              canGoAway = false;
              response.errors.forEach(function (field, message) {
                  showErrorAtField(field, message);
              })
          } else {
              $form.closest('.leadbox.staged').find('.leadbox-stage[data-stage=1]').hide();
              $form.closest('.leadbox.staged').find('.leadbox-stage-success').removeClass('hidden');

              dataLayer.push({
                  'event': 'ga.event',
                  'eCategory': 'Fotovoltaika',
                  'eAction': 'Cold-lead',
                  'eLabel': 'EON',
              });
          }

          if (response.message) {
              canGoAway = false;
          }
      }).catch(function(err) {
          alert('Při odesílání formuláře došlo k neočekávané chybě. Zkuste to prosím znovu.');
          throw err;
      });
   });
});


// WEBPACK FOOTER //
// ./app/Resources/assets/js/components/form.leadbox.js